import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue';
import { dispatchGetCompanySdsesCount } from '@/store/main/actionsMain';
import { RoleId, StatusId, SdsMaximumUpload } from '@/lib/enum';
import { defineMessages } from '@/lib/i18n';
import { useCompanyFeatureComposable } from '@/composables/useCompanyFeatures';
import sharedMessages from '@/lib/shared-messages';
import { store } from '@/store/index';
import {
  readAssertedCompany,
  readAssertedCompanyId,
  readAssertedUserProfile,
} from '@/store/main/getters';
import {
  updateSdsCountDone,
  updateSdsCountSignal,
} from '@/signals/UpdateSdsCount';


export default /*#__PURE__*/_defineComponent({
  __name: 'StatusBar',
  setup(__props) {

const { COMPANY_FEATURES, isFeatureActive } = useCompanyFeatureComposable();

const m = defineMessages({
  using: '{0}を利用中',
  currentRole: '{0}権限で利用中',
  registeredSdsCount: '登録SDS件数',
  registrationSummary: '{registered}件（データ化完了: {completed}件） / {max}',
  latestSds: '最新版SDS　{count}件',
  allSdses: '全SDS件数　{total}件（データ化完了: {completed}件）',
});

const latestTotal = ref(0);
const completedTotal = ref(0);
const allTotal = ref(0);
const keywordList = ref<Array<string>>([]);
const secondCheckDoneToCompletedStatusIdList = ref<Array<number>>([
  ...StatusId.secondCheckDoneToCompletedValues(),
]);

const role = computed(
  () => RoleId.fromRoleId(readAssertedUserProfile(store).role.id).messageId
);
const maximumUpload = computed((): SdsMaximumUpload => {
  return SdsMaximumUpload.fromUpload(readAssertedCompany(store).maximum_upload);
});
const isCountOnlyLatestSDS = computed(() =>
  isFeatureActive(COMPANY_FEATURES.COUNT_ONLY_LATEST_SDS)
);
const isOverLimit = computed(() => {
  return (
    !maximumUpload.value.isUnlimited() &&
    latestTotal.value > maximumUpload.value.value
  );
});

const fetchCompanySdsesCountWithAll = async (): Promise<void> => {
  const res = await dispatchGetCompanySdsesCount(store, {
    companyId: readAssertedCompanyId(store),
    data: {
      keyword_list: keywordList.value,
      status_id_list: [...StatusId.values()],
    },
  });
  if (res) {
    allTotal.value = res.data.total;
  }
};

const fetchCompanySdsesCountWithDone = async (): Promise<void> => {
  const res = await dispatchGetCompanySdsesCount(store, {
    companyId: readAssertedCompanyId(store),
    data: {
      keyword_list: keywordList.value,
      status_id_list: secondCheckDoneToCompletedStatusIdList.value,
    },
  });
  if (res) {
    completedTotal.value = res.data.total;
  }
};

const fetchCompanySdsesCountLatestTotal = async (): Promise<void> => {
  const res = await dispatchGetCompanySdsesCount(store, {
    companyId: readAssertedCompanyId(store),
    data: {
      keyword_list: keywordList.value,
      status_id_list: secondCheckDoneToCompletedStatusIdList.value,
      is_latest_only: true,
    },
  });
  if (res) {
    latestTotal.value = res.data.total;
  }
};

watch(updateSdsCountSignal, async () => {
  await fetchCompanySdsesCountWithAll();
  await fetchCompanySdsesCountWithDone();
  if (isCountOnlyLatestSDS.value) {
    await fetchCompanySdsesCountLatestTotal();
  }
  updateSdsCountDone();
});

onMounted(() => {
  fetchCompanySdsesCountWithAll();
  fetchCompanySdsesCountWithDone();
  if (isCountOnlyLatestSDS.value) {
    fetchCompanySdsesCountLatestTotal();
  }
});

return { __sfc: true,COMPANY_FEATURES, isFeatureActive, m, latestTotal, completedTotal, allTotal, keywordList, secondCheckDoneToCompletedStatusIdList, role, maximumUpload, isCountOnlyLatestSDS, isOverLimit, fetchCompanySdsesCountWithAll, fetchCompanySdsesCountWithDone, fetchCompanySdsesCountLatestTotal, sharedMessages }
}

})